const green = 'rgb(14, 203, 129)'
const red = 'rgb(246, 70, 93)'
const statusSuccess = 'rgb(14, 203, 129)'
const upColor = green
const downColor = red

const colors = {
  green,
  statusSuccess,
  statusCanceled: 'rgb(164 164 164)',
  upColor,
  downColor,
}

export default colors
